import styled from 'styled-components'
import { Alert } from 'shards-react'

export const PasswordViewContainer = styled.div`
    width: 100vw;
    height: 100vh;
    overflow: hidden;
`

export const CustomizedAlert = styled(Alert)`
    font-weight: 500;

    @media (min-width: 1100px) {
        font-size: 1.2em;
        letter-spacing: 1px;
        font-weight: 600;
    }
`

export const FormAuthConatiner = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    font-family: Roboto, Helvetica, Arial, sans - serif;
`
